import React from 'react';

import Topics from './Topics';

const CurrentCampaign = () => (
  <Topics />
);

export default CurrentCampaign;
